import React, { Component } from "react";
import { fire, auth } from "../../../firebase/index";
import LocalizedStrings from "react-localization";

let localizationStrings = new LocalizedStrings({
  en: {
    reply1:
      "eGeeTouch® Smart luggage lock has been tested by TÜV SÜD in conformance with FCC and CE. Inside the aircraft baggage or cabin compartments, there is no emission from the smartlock as it automatically powers off by itself within 10 seconds each time whenever it is turned on. Intelligent firmware protocol and safety mechanical design of button prevent unintentional turning on itself when luggage is in contact/collision with nearby luggage/objects in compartments during transportation.",
    reply2:
      "The batteries used for eGeeTouch smart travel locks are in compliance with International Air Transport Association (IATA) & International Civil Aviation Organization (ICAO) directives for safety and security. For more info on Tests & Certifications, ",
    reply3: "click here",
    back: "Back",
  },
  ja: {
    reply1:
      "eGeeTouch® スマート ラゲッジ ロックは、FCC および CE に準拠してテュフズードによってテストされています。航空機の手荷物または機内コンパートメント内では、スマートロックの電源がオンになるたびに 10 秒以内に自動的に電源がオフになるため、スマートロックからの放出はありません。インテリジェントなファームウェアプロトコルとボタンの安全機械設計により、輸送中に荷物が近くの荷物やコンパートメント内の物体と接触/衝突した場合に、意図せずボタン自体がオンになるのを防ぎます。",
    reply2:
      "eGeeTouch スマート トラベル ロックに使用されるバッテリーは、安全性とセキュリティに関する国際航空運送協会 (IATA) および国際民間航空機関 (ICAO) の指令に準拠しています。テストと認定の詳細については、",
    reply3: "ここをクリック",
    back: "戻る",
  },
  es: {
    reply1:
      "El candado de equipaje inteligente eGeeTouch® ha sido probado por TÜV SÜD de conformidad con FCC y CE. Dentro del equipaje del avión o en los compartimentos de la cabina, la candado inteligente no produce emisiones, ya que se apaga automáticamente en 10 segundos cada vez que se enciende. El protocolo de firmware inteligente y el diseño mecánico de seguridad del botón evitan que se gire involuntariamente cuando el equipaje entra en contacto/colisión con equipaje/objetos cercanos en los compartimentos durante el transporte.",
    reply2:
      "Las baterías utilizadas para las candados de viaje inteligentes eGeeTouch cumplen con las directivas de seguridad de la Asociación de Transporte Aéreo Internacional (IATA) y la Organización de Aviación Civil Internacional (OACI). Para obtener más información sobre pruebas y certificaciones, ",
    reply3: "haga clic aquí",
    back: "Atrás",
  },
});

class Q25_component extends Component {
  constructor(props) {
    super(props);

    this.state = {
      triggerValue: "0",
      clicked: false,
      language: "en",
    };
  }

  componentDidMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          localizationStrings.setLanguage(snapshot.val());
          this.setState({ language: snapshot.val() });
        });
    }
  }

  handleButtonClick2 = () => {
    if (!this.state.clicked) {
      this.setState({ triggerValue: "cancel", clicked: true }, () => {
        this.props.triggerNextStep({
          value: "cancel",
          trigger: "cancel",
        });
      });
    }
  };

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    const buttonStyle = {
      marginTop: "10px",
      width: "215px",
      backgroundColor: "#FFC500",
      color: "black",
      borderRadius: "25px",
      textAlign: "center",
      padding: "10px 10px",
      cursor: "pointer",
      transition: "background-color 0.3s",
      border: "none",
    };

    const buttonHoverStyle = {
      color: "white",
      backgroundColor: "#EF6C00",
    };

    const { triggerValue, clicked } = this.state;

    return (
      <div>
        {localizationStrings.reply1}
        <br />
        <br />
        {localizationStrings.reply2}
        <a
          href="http://www.egeetouch.com/support/certificates"
          target="_blank"
          style={{ textDecoration: "underline", color: "black" }}
        >
          {localizationStrings.reply3}
        </a>
        {this.state.language === "ja" ? "。" : "."}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            margin: "12px 0",
          }}
        >
          <button
            style={{
              ...buttonStyle,
              ...(triggerValue === "cancel" && buttonHoverStyle),
            }}
            onMouseEnter={() => this.setState({ isButtonHovered: true })}
            onMouseLeave={() => this.setState({ isButtonHovered: false })}
            onClick={this.handleButtonClick2}
            disabled={clicked}
          >
            {localizationStrings.back}
          </button>
        </div>
      </div>
    );
  }
}

export default Q25_component;
